import { defineMessages } from 'react-intl';

const prefix = 'repvisits.search.map-view';

const messages = defineMessages({
  markerDescriptionActive: {
    id: `${prefix}.markerDescriptionActive`,
    defaultMessage: 'Selected high school',
  },
  markerDescriptionRepVisits: {
    id: `${prefix}.markerDescriptionRepVisits`,
    defaultMessage: 'RepVisits high schools',
  },
  markerDescriptionOther: {
    id: `${prefix}.markerDescriptionOther`,
    defaultMessage: 'Other high schools',
  },
  actionShowOther: {
    id: `${prefix}.actionShowOther`,
    defaultMessage: 'Show',
  },
  actionHideOther: {
    id: `${prefix}.actionHideOther`,
    defaultMessage: 'Hide',
  },
});

export default messages;
